<main class="thp-container">
<app-talent-happy-path-header [headerText]="headerText"></app-talent-happy-path-header>
  <div class="thp-container-body">
    <div class="progress-bar" *ngIf="activePage !== TalentProfilePage.EMPLOYMENT_SPLASH_PAGE && !isFromGather()">
      <mat-progress-bar mode="determinate"[value]="getCompletionPercentage()"></mat-progress-bar>
      <p class="progress-bar-description">
        {{this.getActivePageNumber()}} {{'talent-happy-path.talent-profile.progress-bar-description.of' | translate}} {{totalPages}} {{'talent-happy-path.talent-profile.progress-bar-description.sections' | translate}}
      </p>
    </div>
    <app-employment-splash-page *ngIf="activePage === TalentProfilePage.EMPLOYMENT_SPLASH_PAGE"></app-employment-splash-page>
    <app-employment-opportunities *ngIf="activePage === TalentProfilePage.EMPLOYMENT_OPPORTUNITIES"></app-employment-opportunities>
    <app-employment-preferences *ngIf="activePage === TalentProfilePage.EMPLOYMENT_PREFERENCES"></app-employment-preferences>
    <app-employment-authorization *ngIf="activePage === TalentProfilePage.EMPLOYMENT_AUTHORIZATION"></app-employment-authorization>
    <app-employment-salary *ngIf="activePage === TalentProfilePage.EMPLOYMENT_SALARY"></app-employment-salary>
    <app-talent-eeoc *ngIf="activePage === TalentProfilePage.TALENT_EEOC"></app-talent-eeoc>
    <router-outlet></router-outlet>
  </div>
<app-talent-happy-path-footer [postingInfo]="postingInfo" class="thp-footer"></app-talent-happy-path-footer>
</main>
